import {AbstractModel} from './abstract.model';

export interface OrganizationByRoleModel extends AbstractModel {
  roles?: number[];
  filterText?: string;
}
